/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InternalUisceneSurfaceHotspotDTO } from '../models/InternalUisceneSurfaceHotspotDTO';
import type { InternalUisceneSurfaceHotspotDTOODataListResponse } from '../models/InternalUisceneSurfaceHotspotDTOODataListResponse';
import type { UisceneSurfaceHotspot } from '../models/UisceneSurfaceHotspot';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InternalUisceneSurfaceHotspotService {

    /**
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns InternalUisceneSurfaceHotspotDTOODataListResponse Success
     * @throws ApiError
     */
    public static getInternalUisceneSurfaceHotspot(
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<InternalUisceneSurfaceHotspotDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/UisceneSurfaceHotspot',
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns InternalUisceneSurfaceHotspotDTO Success
     * @throws ApiError
     */
    public static postInternalUisceneSurfaceHotspot(
requestBody?: InternalUisceneSurfaceHotspotDTO,
): CancelablePromise<InternalUisceneSurfaceHotspotDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/UisceneSurfaceHotspot',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns InternalUisceneSurfaceHotspotDTO Success
     * @throws ApiError
     */
    public static getInternalUisceneSurfaceHotspot1(
key: number,
): CancelablePromise<InternalUisceneSurfaceHotspotDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/UisceneSurfaceHotspot/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns InternalUisceneSurfaceHotspotDTO Success
     * @throws ApiError
     */
    public static putInternalUisceneSurfaceHotspot(
key: number,
requestBody?: InternalUisceneSurfaceHotspotDTO,
): CancelablePromise<InternalUisceneSurfaceHotspotDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal/UisceneSurfaceHotspot/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteInternalUisceneSurfaceHotspot(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/internal/UisceneSurfaceHotspot/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param clientId 
     * @param query 
     * @returns UisceneSurfaceHotspot Success
     * @throws ApiError
     */
    public static getInternalUisceneSurfaceHotspotQuery(
clientId?: number,
query?: string,
): CancelablePromise<Array<UisceneSurfaceHotspot>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/UisceneSurfaceHotspot/query',
            query: {
                'clientId': clientId,
                'query': query,
            },
        });
    }

}
